import React, { useState, useEffect, useRef } from 'react';
import "../AddClients/tableStyle.css";
import { getDispatch } from '../../Services/Services';
import { Row, Col, Input, Button } from 'antd'; // Import DatePicker
import '../AddClients/tableStyle.css';
import Header from '../Header-Footer/Header';
import { useReactToPrint } from 'react-to-print';
import { Link } from 'react-router-dom';
import { FaFilePdf, FaFileExcel } from 'react-icons/fa';
import * as XLSX from 'xlsx';
import Footer from '../Header-Footer/Footer';
export default function OrderDetail() {
  const [deliveryOrder, setDeliveryOrder] = useState([]);
  const [filterByTransporterName, setFilterByTransporterName] = useState('');
  const [filterBydoNumber, setFilterBydoNumber] = useState([]); // State for start date filter
  const [filterByPanNo, setFilterByPanNo] = useState('');
  const [orderList, setOrderList] = useState([])
  const [vehicleNo, setvehicleNo] = useState('');
  useEffect(() => {
    GetDeliveryOrderDetails();
  }, []);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const GetDeliveryOrderDetails = async () => {
    const response = await getDispatch({'type':true,'com_name':localStorage.getItem('com_name')});
    if (response) {
      setDeliveryOrder(response);
      setOrderList(response)
    }
   
  }
  useEffect(() => {
    setDeliveryOrder(orderList.filter((res) => res.truck_owner_name.includes(filterByTransporterName)))

  }, [filterByTransporterName])

  useEffect(() => {
    setDeliveryOrder(orderList.filter((res) => res.do_no.includes(filterBydoNumber)))

  }, [filterBydoNumber])

  useEffect(() => {
    setDeliveryOrder(orderList.filter((res) => res.pan_no.includes(filterByPanNo)))

  }, [filterByPanNo])
  useEffect(() => {
    setDeliveryOrder(orderList.filter((res) => res.client_name.toLowerCase().includes(vehicleNo.toLowerCase())))

  }, [vehicleNo])
  useEffect(() => {
    setDeliveryOrder(orderList.filter((res) => res.vehicle_no.toLowerCase().includes(vehicleNo.toLowerCase())))

  }, [vehicleNo])

  const handleExportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const wsData = deliveryOrder.map((e, index) => [
      index + 1,
      e.client_name,
      e.do_no,
      e.truck_owner_name,
      e.pan_no,
      e.vehicle_no,
      e.dispatch_quantity,
      e.received_quantity,
      e.freight_quantity,
      e.sort_quantity,
      e.moisture_received_per,
      e.actual_quantity,
      e.moisture_deduct_quantity,
      e.moisture_amount,
      e.moisture_deduct,
      e.sort_amount,
      e.freight_rate,
      e.freight_amount,
      e.tds_per,
      e.tds,
      e.advance,
      e.commision,
      e.pay_amount,
      e.date,
      // Add other fields here based on your table structure
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      [
        'Sr. No',
        'Party Name',
        'Do Number',
        'Truck Owner Name',
        'Pan No',
        'Vehicle No',
        'Dipatch Qty',
        'Recieved Qty',
        'Freight Qty',
        'Sort Qty',
        'Moisture',
        'Actual Qty',
        'Moisture Deduct Qty',
        'Moisture Amt',
        'Moisture Deduct',
        'Sort Amount',
        'Freight Rate',
        'Freight Amt',
        'Tds %',
        'Tds Amt',
        'Advance Amt',
        'Commision Amt',
        'Pay Amt',
        'Received Date',
        // Add other headers here based on your table structure
      ],
      ...wsData,
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'DeliveryOrderDetails');

    XLSX.writeFile(workbook, 'Today Order List.xlsx');
  };
  const formateDate =(date)=>{
    const [year, month, day] = date.split('-');
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate
  }
  
  return (
    <div style={{ height:'90vh' }}>
      <Header heading="TODAY FREIGHT VIEW" />
      <div className=" grid grid-cols-1 sm:grid sm:grid-cols-5 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%]" style={{ marginBottom: '10px' }}>
        <Col>
          <label><b>Search By Truck Owner Name</b></label><br />
          <Input
            placeholder='Search By Truck Owner Name'
            value={filterByTransporterName}
            onChange={(e) => setFilterByTransporterName(e.target.value)}
          />
        </Col>
        <Col>
          <label><b> Search By Do Number</b></label><br />
          <Input
            value={filterBydoNumber}
            onChange={(e) => setFilterBydoNumber(e.target.value)}
            placeholder='Search By Do Number'
          />
        </Col>
        <Col>
          <label><b> Search By PAN No</b></label><br />
          <Input
            placeholder='Search by PAN No.'
            value={filterByPanNo}
            onChange={(e) => setFilterByPanNo(e.target.value)}
          />
        </Col>
        <Col>
          <label><b> Search By Vehicle No</b></label><br />
          <Input
            placeholder='Search by Vehicle No.'
            value={vehicleNo}
            onChange={(e) => setvehicleNo(e.target.value)}
          />
        </Col>
        <Col>

          <Button
            style={{
              top:'10px',
              margin: "10px",
              backgroundColor: 'black',
              color: 'white',
              fontWeight: '600'
            }}
            onClick={handlePrint}
          >
            <FaFilePdf/>
          </Button>
          <Button
            style={{
               top:'10px',
              margin: "10px",
              backgroundColor: 'green',
              color: 'white',
              fontWeight: '600'
            }}
            onClick={handleExportToExcel}
          >
          <FaFileExcel/>
          </Button>
        </Col>
      </div>
      <div ref={componentRef} className="overflow-x-auto">
        <table id="my-table" className="w-full relative">
          <thead className="bg-[#151B54] w-full text-white">
            <tr>
              <th >Sr. No</th>
              <th >Id</th>
              <th>Do No</th>
              <th>Truck Owner Name</th>
              <th>Pan No</th>
              <th>Vehicle No</th>
              <th>Dipatch Qty</th>
              <th>Recieved Qty</th>
              <th>Freight Qty</th>
              <th>Sort Qty</th>
              <th>Moisture %</th>
              <th>Actual Qty</th>
              <th>Moisture Deduct Qty</th>
              <th>Moisture Amt</th>

              <th>Moisture Deduct</th>
              <th>Sort Amount</th>
              <th>Freight Rate</th>
              <th>Freight Amt</th>
              <th>Tds %</th>
              <th>Tds Amt</th>
              <th>Advance Amt</th>
              <th>Commision Amt</th>
              <th>Pay Amt</th>
              <th>Dispatch Date</th>
              <th>Received Date</th>

            </tr>
          </thead>
          <tbody>
            {deliveryOrder.map((e, index) => (
              <tr>
                <td>{index + 1}</td>
                <td>{e.id}</td>
                <td >
                  <Link to={`/do-view/${e.do_id}`}><u style={{ fontWeight: '600', color: 'blue' }}>
                    {e.do_no}
                  </u></Link>
                </td>
                <td>{e.truck_owner_name}</td>
                <td>{e.pan_no}</td>
                <td>{e.vehicle_no}</td>
                <td>{(e.dispatch_quantity).toFixed(3)}</td>
                <td>{(e.received_quantity).toFixed(3)}</td>
                <td>{(e.freight_quantity).toFixed(3)}</td>
                <td>{e.sort_quantity}</td>
                <td>{e.moisture_received_per}</td>
                <td>{e.actual_quantity}</td>
                <td>{e.moisture_deduct_quantity}</td>
                <td>{e.moisture_amount}</td>
                <td>{e.moisture_deduct}</td>
                <td>{e.sort_amount}</td>
                <td>{e.freight_rate}</td>
                <td>{e.freight_amount}</td>
                <td>{e.tds_per}</td>
                <td>{e.tds}</td>
                <td>{e.advance}</td>
                <td>{e.commision}</td>
                <td>{e.pay_amount}</td>
                <td>{formateDate(e.date)}</td>
                <td>{formateDate(e.received_date)}</td>

              </tr>
            ))}
            <tr style={{ backgroundColor: '#e9e9e9' }}>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base" colSpan={6}><b>Total</b></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>{deliveryOrder.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.dispatch_quantity),
                  0
                ).toFixed(3)}</b></td>
                    <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>{deliveryOrder.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.received_quantity),
                  0
                ).toFixed(3)}</b></td>
                    <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>{deliveryOrder.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.freight_quantity),
                  0
                ).toFixed(3)}</b></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base" colSpan={4}><b></b></td>
              
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>{deliveryOrder.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.moisture_amount),
                  0
                ).toFixed(2)}</b></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>{deliveryOrder.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.moisture_deduct),
                  0
                ).toFixed(2)}</b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>{deliveryOrder.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.sort_amount),
                  0
                ).toFixed(2)}</b>
              </td>

              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>{deliveryOrder.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.freight_amount),
                  0
                ).toFixed(2)}</b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">

              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>{deliveryOrder.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.tds),
                  0
                ).toFixed(2)}</b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>{deliveryOrder.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.advance),
                  0
                ).toFixed(2)}</b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>{deliveryOrder.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.commision),
                  0
                ).toFixed(2)}</b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>{deliveryOrder.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.pay_amount),
                  0
                ).toFixed(2)}
                </b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base" colSpan={2}></td>
            </tr>
          </tbody>
        </table>

      </div>
      {/* <Footer /> */}
    </div>
  )
}
